import React from 'react';
import SADropdown from "../../common/dropdown/SADropdown";
import {injectIntl} from "react-intl";
import Time from "../../../services/Time";
import SACheckbox from "../../common/input/SACheckbox";
import {connect} from "react-redux";

class AvailabilityStart extends React.Component {

  render() {
    const {intl: {formatMessage}, availabilities, error, selectedDates} = this.props;

    const startDates = availabilities.map(a=>a.day);
    const selectedDay = availabilities.find(a=>a.day === selectedDates.startDate) || {slots:[]};

    if (!startDates.includes(selectedDates.startDate)){
      startDates.push(selectedDates.startDate);
    }

    const startTimes = selectedDay.slots;
    if (selectedDates.startTime && !startTimes.includes(selectedDates.startTime)) { // sometimes there aren't any slots for days with 24/7 enabled
      startTimes.push(selectedDates.startTime);
    }

    startDates.sort();
    startTimes.sort();

    return (
      <div className="form-field row">
        <ul className="list col-md-5 col-xxl-5 ">
          <label>{formatMessage({id: 'placeholder.startDate'})}</label>
          <SADropdown name="startDate" value={selectedDates.startDate}
                      choices={startDates.map(d=>({value:d, display:Time.dateFromApiToDisplay(d)}))} onChange={this.props.onDateChange}
                      error={error}/>
        </ul>
        <ul className="list col-md-5 col-xxl-5 ">
          <label>{formatMessage({id: 'placeholder.startTime'})}</label>
          <SADropdown name="startTime" value={selectedDates.startTime}
                      choices={startTimes.map(t=>({value:t, display:Time.timeFromApiToDisplay(t)}))} onChange={this.props.onTimeChange}
                      disabled={!selectedDates.duringWorkingHours || startTimes.length === 0}
                      error={error}/>
        </ul>
        {selectedDay.twentyFourSevenAvailable &&
          <ul className="list col-md-2 col-xxl-2 ">
            <label>{formatMessage({id: '24/7'})}</label>
          <SACheckbox name="duringWorkingHours" checked={!selectedDates.duringWorkingHours}
                      onChange={this.props.onTwentyFourChange}
                      error={error}/>
          </ul>
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  mainServices: state.fetchMainServices.mainServices || {},
  fetchAvailabilities: state.fetchAvailabilities,
  fetchOpeningHours: state.fetchOpeningHours.openingHours,
});

export default connect(
  mapStateToProps,
  null
)(injectIntl(AvailabilityStart))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/planning/AvailabilityStart.js